<div class=" p-3">
    <div class="d-flex justify-content-between my-4 mx-3">
        <div class="row">
            <h5>
                 {{ schemeType === 'tdf' ? 'Evaluation of TPR' : 'Technical Evaluation' }}
               
                <span class="text-primary">[{{payload?.proposal_name}}]</span>
            </h5>

            <h6><span class="text-primary"> [
                    {{
                    stepDetails?.step_status == 0
                    ? 'INITIATION PENDING'
                    : (stepDetails?.step_status | uppercase)
                    }}
                    ]</span></h6>
        </div>
        <div class="d-flex gap-2">
            <p-button pTooltip="Generate PDF" icon="pi pi-file-pdf" (onClick)="generatePDF()" [outlined]="true"></p-button>
            <!-- <p-button pTooltip="Edit Form" icon="pi pi-pencil" (onClick)="editForm()" [outlined]="true"></p-button> -->
            <p-button label="Submit" icon="pi pi-save" (onClick)="onSubmit()" [outlined]="true"
                *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6)"></p-button>
            <p-button label="Next" icon="pi pi-angle-right" iconPos="right" (onClick)="goToNextStep()"
                [outlined]="true" *ngIf="stepDetails?.step_status == 'approved'"></p-button>
            <p-button label="Initiate" icon="pi pi-play" *ngIf="stepDetails?.is_initiator"
                (onClick)="IRA.emit('Initiate')" [outlined]="true"></p-button>
            <p-button label="Approve" icon="pi pi-check-circle" *ngIf="stepDetails?.is_approver"
                (onClick)="IRA.emit('Approve')" [outlined]="true"></p-button>
            <p-button label="Recommend" icon="pi pi-thumbs-up" *ngIf="stepDetails?.is_recommender"
                (onClick)="IRA.emit('Recommend')" [outlined]="true"></p-button>

        </div>
    </div>
    <hr>
    <div class="mb-5">
        <!-- <p-accordion [multiple]="false">
            <ng-container *ngFor="let vendor of vendorsDoc; let i = index">
                <p-accordion-panel [value]="i">
                    <p-accordion-header class="mt-4 rounded-top border ">
                        <ng-template #toggleicon let-active="active">
                            <div class="d-flex gap-2 align-items-center">
                                <i class="pi" [ngClass]="active ? 'pi-minus' : 'pi-plus'"></i>
                            </div>
                        </ng-template>
                        <span class="d-flex justify-content-between align-items-center gap-2 w-full">
                            <span class="font-bold whitespace-nowrap">{{ vendor.name }}</span>
                        </span>
                    </p-accordion-header>

                    <p-accordion-content>
                        <p class="text-muted">Based on RFP Appendix S</p>

                        <div class="vendor-criteria-table m-3">
                            <p-table [value]="vendor.entries" styleClass="p-datatable-sm">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th class="wid-5-percent">S.No</th>
                                        <th sclass="wid-75-percent">Criteria</th>
                                        <th class="wid-10-percent">View</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-entry let-rowIndex="rowIndex">
                                    <tr>
                                        <td>{{ rowIndex + 1 }}</td>
                                        <td>{{entry.criteriaName}}</td>
                                        <td>
                                            <a [href]="entry.criteriaName !== 'Commercial Bid' ? apiUrl + entry.document : null"
                                                target="_blank" *ngIf="entry.document"
                                                [attr.disabled]="entry.criteriaName === 'Commercial Bid' ? true : null"
                                                [ngClass]="{ 'disabled-link': entry.criteriaName === 'Commercial Bid' }"
                                                rel="noopener noreferrer"><i class="pi pi-eye"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </ng-container>
        </p-accordion> -->
    </div>
    <div class="overflow-x-auto max-wid-1200">
        <table class="min-w-full bg-white border-collapse width-100-percent">
            <thead>
                <tr class="bg-gray-100" *ngIf="vendorNames.length > 0">
                    <th class="border p-3 text-left min-w-[50px]">Sr</th>
                    <th class="border p-3 text-left min-w-[300px]">Criteria</th>
                    <th *ngFor="let vendor of vendorNames" class="border p-3 text-center min-w-[200px]">
                        {{vendor}}
                        <div class="text-xs font-normal">Compliance (Yes/No)</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of qualifiedFeild; let i = index" [ngClass]="{'bg-gray-50': i % 2 === 0}">
                    <td class="border p-3 text-center">{{ row.id }}</td>
                    <td class="border p-3">{{ row.criteria }}</td>
                    <ng-container>
                        <td *ngFor="let vendor of vendorNames" class="border p-3 text-center">
                            <div class="d-flex justify-center align-items-center gap-2">
                                <span *ngIf="row.vendors[vendor]?.document_flag">Yes</span> <br>
                                <span *ngIf="!row.vendors[vendor]?.document_flag">No</span> <br>
                               
                            </div>
                        </td>
                    </ng-container>
                </tr>
                <tr *ngIf="vendorNames.length > 0">
                    <td class="border p-3"></td>
                    <td class="border p-3 font-semibold">Qualification Status</td>
                    <td *ngFor="let vendor of vendorNames" class="border p-3 text-center">
                        <input type="radio" [name]="'status-' + vendor" [value]="'Qualified'"
                            [checked]="vendorStatusMap[vendor] === 'Qualify'"
                            (change)="onVendorStatusChange(vendor, 'Qualified')" [disabled]="!(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6))"  />
                        Qualified
                        <br>
                        <input type="radio" [name]="'status-' + vendor" [value]="'Disqualified'"
                            [checked]="vendorStatusMap[vendor] === 'Disqualify'"
                            (change)="onVendorStatusChange(vendor, 'Disqualified')" [disabled]="!(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender|| (stepDetails?.step_status != 'approved' && userID == 6))"  />
                        Disqualified
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <form [formGroup]="JustificationForm">
        <div class="form-group mb-4 editor-container mt-4" [class.readonly-editor]="isEditorDisabled">
            <label for="pdsTitle"><strong>• Justification</strong></label>
            <editor [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>
        </div>

    </form>
</div>